import FormattedMessage from 'I18n/components/FormattedMessage';
import { isDateRangeGeneratedQuickFilterGroup, isOwnersGeneratedQuickFilterGroup, isTeamsGeneratedQuickFilterGroup } from '../../../../../lib/dashboardFilters/groupQuickFilterHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
export const useQuickFilterGroupNameAndDesc = quickFilterGroup => {
  if (isDateRangeGeneratedQuickFilterGroup(quickFilterGroup)) {
    return {
      name: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quickFilter.groupedQuickFilter.generation.dateRange.name"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quickFilter.groupedQuickFilter.generation.dateRange.description"
      })
    };
  }
  if (isOwnersGeneratedQuickFilterGroup(quickFilterGroup)) {
    return {
      name: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quickFilter.groupedQuickFilter.generation.owners.name"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quickFilter.groupedQuickFilter.generation.owners.description"
      })
    };
  }
  if (isTeamsGeneratedQuickFilterGroup(quickFilterGroup)) {
    return {
      name: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quickFilter.groupedQuickFilter.generation.teams.name"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quickFilter.groupedQuickFilter.generation.teams.description"
      })
    };
  }
  const {
    name,
    description
  } = quickFilterGroup;
  return {
    name,
    description
  };
};